import { render, staticRenderFns } from "./StayType.vue?vue&type=template&id=bffb7b42&scoped=true&"
import script from "./StayType.vue?vue&type=script&lang=js&"
export * from "./StayType.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bffb7b42",
  null
  
)

export default component.exports